export { default } from './file-upload-sample-files';
